// extracted by mini-css-extract-plugin
module.exports = {"container":"_3duoGWtRewpxAGKxZC5FbQ","icon":"_8B1riWpC6ltYxmBDvwWaG","title":"_1oGadYa2iDkZqlXrec7LQV","text":"_325kZb6UCVydzPYxM8w-n8","retryBtn":"_2EEmp1PmQyofobC4z4M8s2"};